// extracted by mini-css-extract-plugin
export var details = "_fs-0";
export var inspectorPopover = "_fs-1";